import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    cell: {
      ...theme.typography.semiBold12,
      padding: theme.spacing(1.5, 2),
      background: 'transparent',
      borderBottom: theme.shape.borderGray60,
    },
    cellFavorite: {
      width: 48,
    },
    cellName: {},
    // Four 20px tool icons, their gaps and a "+N" count, plus the cell's padding.
    cellType: {
      width: 150,
    },
    cellDescription: {
      width: 220,
    },
    cellMenu: {
      width: 48,
    },
  }),
  { name: 'HeaderRow' }
);
